import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    categories: require("@/data/categories.json")
  },
  getters: {
    categories: state => {
      return state.categories;
    },
    getCategoriesById: state => id => {
      console.log(id);
      return state.categories.find(category => category.id === id);
    },
    getCategoriesByPageName: state => pageName => {
      return state.categories.find(category => category.pageName === pageName);
    }
  }
});
